import { ApiResponse } from 'types/api';
import { DashboardProfile, UpdateProfileRequest } from 'types/user';

import { apiRequest } from 'services/api/client';

export const userService = {
  getDashboard() {
    return apiRequest<ApiResponse<DashboardProfile>>('/user/dashboard', {
      method: 'GET',
      auth: true,
    });
  },

  updateProfile(payload: UpdateProfileRequest) {
    return apiRequest<ApiResponse<Record<string, unknown>>>('/user/profile', {
      method: 'PUT',
      body: payload,
      auth: true,
    });
  },
};
